import axios from 'axios'
import { apiRequest } from './apiRequest'
import { CONST } from '../constant'

/**
 * @returns name string
 */
export const getProfileName = async (cid) => {
  const response = await apiRequest(`/api/community/${cid}/profile-name/`, CONST.api_method.get)
  return response.data
}

/**
 * fetch all communities's member
 * @returns {Promise}
 */
export const getGroupsAndCommunityMembers = async (
  cid,
  includeInvalid,
  includeEntry,
  onlyAdmin,
  restrictCmid
) => {
  const response = await apiRequest(
    `/api/cm/${cid}/group-member/?includeInvalid=${!!includeInvalid}&includeEntry=${!!includeEntry}&onlyAdmin=${!!onlyAdmin}&restrictCmid=${
      restrictCmid ? restrictCmid : 0
    }`,
    CONST.api_method.get
  )
  return response.data
}

/**
 * fetch communities's member
 * @returns {Promise}
 */
export const getCommunityMembers = async (
  cid,
  includeInvalid,
  includeEntry,
  onlyAdmin,
  restrictCmid
) => {
  const response = await apiRequest(
    `/api/cm/${cid}/member/?includeInvalid=${!!includeInvalid}&includeEntry=${!!includeEntry}&onlyAdmin=${!!onlyAdmin}&restrictCmid=${
      restrictCmid ? restrictCmid : 0
    }`,
    CONST.api_method.get
  )
  return response.data
}

export const getFriends = async (type, typeId) => {
  const response = await apiRequest(`/api/cm/friend/${type}/${typeId}`, CONST.api_method.get)
  return response.data
}

export const getInactiveMembers = async (cid) => {
  const response = await apiRequest(`/api/cm/${cid}/inactive-member/`, CONST.api_method.get)
  return response.data
}

export const getCmids = async (cid, all, gids) => {
  const response = await apiRequest(
    `/api/cm/${cid}/cmids/?all=${!!all}&gids=${gids ? gids.join() : ''}`,
    CONST.api_method.get
  )
  return response
}

export const fetchCommunityManagers = async (cid) => {
  const response = await apiRequest(`/api/community/${cid}/manager`, CONST.api_method.get)
  return response
}

/**  Invitation link API  **/

export const getInviteLink = async (cid, includeInvalid) => {
  const response = await apiRequest(
    `/api/community/${cid}/invitelink?includeInvalid=${includeInvalid}`,
    CONST.api_method.get
  )
  return response.data
}

export const getInviteLinkAll = async (cid, includeInvalid) => {
  const response = await apiRequest(
    `/api/community/${cid}/invitelink/all?includeInvalid=${includeInvalid}`,
    CONST.api_method.get
  )
  return response.data
}

export const invitable = async (cid) => {
  const response = await apiRequest(`/api/community/${cid}/invitable`, CONST.api_method.get)
  return response.data
}

export const createInviteLink = async (data) => {
  const response = await apiRequest('/api/community/invitelink', CONST.api_method.post, data)
  return response.data
}

export const createInviteEmailLinks = async (data) => {
  const response = await apiRequest('/api/community/invitelink-email', CONST.api_method.post, data)
  return response.data
}

export const inviteFromCommunity = async (data) => {
  const response = await apiRequest(
    '/api/community/invite-from-community',
    CONST.api_method.post,
    data
  )
  return response.data
}

export const changeInviteLinkActivation = async (iId, status) => {
  const response = await apiRequest(
    `/api/invitelink/${iId}/activation/?status=${status}`,
    CONST.api_method.post
  )
  return response.data
}

/**
 * issue#30: タグ付き招待QRトークンを取得する。
 * 同じ (parent_invite_id, tag) は同じ code を再利用する（BE 側でべき等）。
 * @param {FormData} data cid / parent_invite_id / tag(最大20文字)
 * @returns bare invite (code 含む)
 */
export const createTagToken = async (data) => {
  const response = await apiRequest(
    '/api/community/invitelink/tag-token',
    CONST.api_method.post,
    data
  )
  return response.data
}

/**
 * issue#30: コミュニティメンバーのタグを付け替える（owner/manager のみ）。
 * @param {FormData} data cid / cmid / tag
 */
export const retagCommunityMember = async (data) => {
  const response = await apiRequest('/api/community/member/retag', CONST.api_method.post, data)
  return response.data
}

/**
 * issue#30: フレンドのタグを付け替える（招待者本人のみ）。
 * @param {FormData} data friend_mid / tag
 */
export const retagFriend = async (data) => {
  const response = await apiRequest('/api/community/friend/retag', CONST.api_method.post, data)
  return response.data
}

export const getInviteLinkInfo = async (type, code) => {
  const response = await apiRequest(`/api/invitelink/${type}/${code}`, CONST.api_method.get)
  return response.data
}

export const acceptInviteLink = async (type, code, data) => {
  const response = await apiRequest(
    `/api/invitelink/accept/${type}/${code}`,
    CONST.api_method.post,
    data,
    true
  )
  return response.data
}

export const acceptInviteFriendLink = async (type, code) => {
  const response = await apiRequest(`/api/invitelink/friend/${type}/${code}`, CONST.api_method.post)
  return response.data
}

export const refuseInviteLink = async (type, code) => {
  const response = await apiRequest(`/api/invitelink/refuse/${type}/${code}`, CONST.api_method.post)
  return response.data
}

export const approve = async (cmid) => {
  const response = await apiRequest(`/api/cm/approve/${cmid}`, CONST.api_method.post)
  return response.data
}

export const reject = async (cmid) => {
  const response = await apiRequest(`/api/cm/reject/${cmid}`, CONST.api_method.post)
  return response.data
}

export const changeRole = async (cmid, data) => {
  const response = await apiRequest(`/api/cm/change-role/${cmid}`, CONST.api_method.post, data)
  return response.data
}

export const unsubscribe = async (cmid, data) => {
  const response = await apiRequest(`/api/cm/unsubscribe/${cmid}`, CONST.api_method.post, data)
  return response.data
}

export const ban = async (cmid) => {
  const response = await apiRequest(`/api/cm/ban/${cmid}`, CONST.api_method.post)
  return response.data
}

export const resetBan = async (cmid) => {
  const response = await apiRequest(`/api/cm/reset-ban/${cmid}`, CONST.api_method.post)
  return response.data
}

/**
 * update community member photo setting
 * @param data
 * @returns {Promise}
 */
export const updateCommunityMemberCover = async (data) => {
  const response = await apiRequest(
    `/api/community/member/cover`,
    CONST.api_method.post,
    data,
    true
  )
  return response.data
}

export const saveNameAndCover = async (data) => {
  const response = await apiRequest(
    `/api/community/member/name-cover`,
    CONST.api_method.post,
    data,
    true
  )
  return response.data
}

export default {
  getProfileName,
  getGroupsAndCommunityMembers,
  getCommunityMembers,
  getFriends,
  getInactiveMembers,
  getCmids,
  fetchCommunityManagers,
  changeInviteLinkActivation,
  createInviteLink,
  createInviteEmailLinks,
  createTagToken,
  retagCommunityMember,
  retagFriend,
  inviteFromCommunity,
  getInviteLink,
  getInviteLinkAll,
  invitable,
  getInviteLinkInfo,
  acceptInviteLink,
  acceptInviteFriendLink,
  refuseInviteLink,
  updateCommunityMemberCover,
  approve,
  reject,
  changeRole,
  unsubscribe,
  ban,
  resetBan,
  saveNameAndCover,
}
